import Flatpickr from 'flatpickr';

// Default calendar selector
const DEFAULT_SELECTOR = '.calendar';

export const DEFAULT_OPTIONS = {
  selector: DEFAULT_SELECTOR
};

class Calendar {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add calendar properties on.
   * */
  constructor(elementRef) {
    // Initialise attributes

    // Root dropdown container
    this.elementRef = elementRef;

    // Bind functions

    this._setup();
  }

  // Event Handlers

  // private

  /**
   * Set-up the calendar.
   * */
  _setup() {
    Flatpickr(this.elementRef, {
      altInput: true,
      altFormat: 'F j, Y',
      dateFormat: 'Y-m-d',
      minDate: new Date().fp_incr(1),
      disableMobile: "true",
      locale: {
        firstDayOfWeek: 1 // start week on Monday
      }
    });
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/calendar/index.js